import { useEffect, useState } from 'react';
import { adminAPI } from '../../services/api';
import toast from 'react-hot-toast';

const R$ = (v) => `R$ ${parseFloat(v || 0).toFixed(2).replace('.', ',')}`;

const BLANK = { code:'', type:'percent', value:'', max_uses:'', valid_from:'', valid_until:'', description:'' };

export default function AdminCoupons() {
  const [coupons,  setCoupons]  = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form,     setForm]     = useState(BLANK);
  const [saving,   setSaving]   = useState(false);

  const load = async () => {
    setLoading(true);
    try { const r = await adminAPI.coupons(); setCoupons(r.data.data || []); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleCreate = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await adminAPI.couponCreate({ ...form, code: form.code.toUpperCase() });
      toast.success('Cupom criado!');
      setShowForm(false);
      setForm(BLANK);
      load();
    } catch (err) {
      toast.error(err.response?.data?.message || 'Erro ao criar cupom.');
    } finally { setSaving(false); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Desativar este cupom?')) return;
    try {
      await adminAPI.couponDelete(id);
      toast.success('Cupom desativado.');
      load();
    } catch { toast.error('Erro ao desativar.'); }
  };

  const inp = { width:'100%', padding:'8px 12px', border:'1.5px solid #E5E7EB', borderRadius:8, outline:'none', fontSize:'.9rem', boxSizing:'border-box' };
  const lbl = { fontSize:'.78rem', fontWeight:600, color:'#6B7280', display:'block', marginBottom:4 };

  return (
    <div>
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <h1 style={{ fontSize:'1.5rem', fontWeight:700, color:'#0F172A' }}>Cupons de Desconto</h1>
        <button onClick={() => setShowForm(s => !s)}
          style={{ padding:'10px 20px', background:'#2563EB', color:'#fff', border:'none', borderRadius:10, fontWeight:700, cursor:'pointer', fontSize:'.9rem' }}>
          {showForm ? '✕ Cancelar' : '+ Novo Cupom'}
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleCreate} style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, padding:24, marginBottom:20 }}>
          <h3 style={{ fontWeight:700, marginBottom:16, color:'#0F172A' }}>Novo Cupom</h3>
          <div style={{ display:'grid', gridTemplateColumns:'repeat(auto-fill,minmax(180px,1fr))', gap:12 }}>
            <label>
              <span style={lbl}>Código *</span>
              <input required style={inp} type="text" value={form.code} onChange={e => set('code', e.target.value)} placeholder="BLACK2025" />
            </label>
            <label>
              <span style={lbl}>Tipo *</span>
              <select required value={form.type} onChange={e => set('type', e.target.value)}
                style={{ ...inp, background:'#fff' }}>
                <option value="percent">Porcentagem (%)</option>
                <option value="fixed">Valor fixo (R$)</option>
              </select>
            </label>
            <label>
              <span style={lbl}>Valor *</span>
              <input required style={inp} type="number" step="0.01" min="0" value={form.value} onChange={e => set('value', e.target.value)}
                placeholder={form.type === 'percent' ? '10' : '50.00'} />
            </label>
            <label>
              <span style={lbl}>Uso máximo</span>
              <input style={inp} type="number" min="1" value={form.max_uses} onChange={e => set('max_uses', e.target.value)} placeholder="Ilimitado" />
            </label>
            <label>
              <span style={lbl}>Válido a partir de</span>
              <input style={inp} type="date" value={form.valid_from} onChange={e => set('valid_from', e.target.value)} />
            </label>
            <label>
              <span style={lbl}>Válido até</span>
              <input style={inp} type="date" value={form.valid_until} onChange={e => set('valid_until', e.target.value)} />
            </label>
            <label style={{ gridColumn:'1/-1' }}>
              <span style={lbl}>Descrição</span>
              <input style={inp} type="text" value={form.description} onChange={e => set('description', e.target.value)} placeholder="Promoção de lançamento" />
            </label>
          </div>
          <div style={{ marginTop:16 }}>
            <button type="submit" disabled={saving}
              style={{ padding:'9px 22px', background:'#059669', color:'#fff', border:'none', borderRadius:8, fontWeight:700, cursor:'pointer', fontSize:'.9rem', opacity: saving ? .7 : 1 }}>
              {saving ? 'Criando...' : 'Criar Cupom'}
            </button>
          </div>
        </form>
      )}

      <div style={{ background:'#fff', border:'1px solid #E5E7EB', borderRadius:12, overflow:'hidden' }}>
        {loading ? (
          <div style={{ padding:40, textAlign:'center', color:'#6B7280' }}>Carregando...</div>
        ) : coupons.length === 0 ? (
          <div style={{ padding:40, textAlign:'center', color:'#6B7280' }}>Nenhum cupom cadastrado ainda.</div>
        ) : (
          <div style={{ overflowX:'auto' }}>
            <table style={{ width:'100%', borderCollapse:'collapse', fontSize:'.88rem' }}>
              <thead>
                <tr style={{ background:'#F8FAFC' }}>
                  {['Código','Tipo','Desconto','Usos','Validade','Status',''].map(h => (
                    <th key={h} style={{ padding:'11px 16px', textAlign:'left', fontWeight:600, color:'#374151', fontSize:'.78rem', whiteSpace:'nowrap' }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {coupons.map(c => (
                  <tr key={c.id} style={{ borderTop:'1px solid #F3F4F6' }}>
                    <td style={{ padding:'11px 16px', fontWeight:700, fontFamily:'monospace', color:'#2563EB', letterSpacing:'.05em' }}>{c.code}</td>
                    <td style={{ padding:'11px 16px', color:'#6B7280' }}>{c.type === 'percent' ? '%' : 'R$'}</td>
                    <td style={{ padding:'11px 16px', fontWeight:600 }}>{c.type === 'percent' ? `${c.value}%` : R$(c.value)}</td>
                    <td style={{ padding:'11px 16px', color:'#6B7280' }}>
                      {c.uses_count || 0}{c.max_uses ? `/${c.max_uses}` : ''}
                    </td>
                    <td style={{ padding:'11px 16px', color:'#6B7280', fontSize:'.8rem', whiteSpace:'nowrap' }}>
                      {c.valid_from ? `${c.valid_from}` : '—'}{c.valid_until ? ` → ${c.valid_until}` : ''}
                    </td>
                    <td style={{ padding:'11px 16px' }}>
                      <span style={{ fontSize:'.75rem', fontWeight:600, padding:'3px 10px', borderRadius:20,
                        background: c.is_active ? '#D1FAE5' : '#FEE2E2',
                        color:      c.is_active ? '#059669' : '#DC2626' }}>
                        {c.is_active ? 'Ativo' : 'Inativo'}
                      </span>
                    </td>
                    <td style={{ padding:'11px 16px' }}>
                      {c.is_active === 1 && (
                        <button onClick={() => handleDelete(c.id)}
                          style={{ padding:'5px 12px', background:'#FEE2E2', color:'#DC2626', border:'none', borderRadius:6, cursor:'pointer', fontSize:'.78rem', fontWeight:600 }}>
                          Desativar
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
